import React from "react";
import AgTable from "../../Analyze/AnalyzeTransactionsTable/AgTable";
import {
  useTransactions,
  useTransactionsAutomaticMode,
} from "../../Analyze/AnalyzeTransactionsTable/hooks";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { fetchTls } from "../../../../redux/reducers/TransactionManager";
type Props = {};
export const AutomaticModeTable: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(fetchTls(true));
  }, []);
  const transactions = useTransactionsAutomaticMode();

  let cols: any[] = [];
  let colNames: string[] = [];

  for (const t of transactions) {
    const keys = Object.keys(t);
    if (keys.length > colNames.length) {
      colNames = keys;
    }
    cols = colNames.map((name) => ({
      field: name,
      headerName: `Col ${name}`,
    }));
  }
  return (
    <AgTable
      columnDefs={cols}
      hasExport={false}
      height={"80vh"}
      width={"100%"}
      rowData={transactions}
      pagination={true}
      paginationAutoPageSize={true}
    />
  );
};
export default AutomaticModeTable;
